import UtilsUrl from "./UtilsUrl";

// Neutral placeholder shown when a product has no image (or the image fails to load)
export const DEFAULT_PRODUCT_IMAGE =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">' +
      '<rect width="64" height="64" fill="#f1f3f5"/>' +
      '<path d="M32 14l15 8v16l-15 8-15-8V22z" fill="none" stroke="#adb5bd" stroke-width="2.5" stroke-linejoin="round"/>' +
      '<path d="M17 22l15 8 15-8M32 30v16" fill="none" stroke="#adb5bd" stroke-width="2.5" stroke-linejoin="round"/>' +
      "</svg>"
  );

const isMissing = (imagePath) =>
  !imagePath || ["null", "undefined", "-"].includes(String(imagePath).trim());

export const productImageSrc = (imagePath) =>
  isMissing(imagePath)
    ? DEFAULT_PRODUCT_IMAGE
    : UtilsUrl.fileRetailURL() + imagePath;

// use as onError={onProductImageError} to fall back when the file is not found
export const onProductImageError = (e) => {
  if (e.currentTarget.src !== DEFAULT_PRODUCT_IMAGE) {
    e.currentTarget.onerror = null;
    e.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
  }
};
